import { useTranslation } from '@/utils/hook'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { IconMenu2, IconX } from '@tabler/icons-react'
import Image from 'next/image'
import styles from './header.module.css'

const navItems = [
  { href: '/product', label: 'common.product' },
  { href: '/templates', label: 'common.templates' },
  { href: '/integrations', label: 'common.integrations' },
  { href: '/pricing', label: 'common.pricing' },
  { href: '/blog', label: 'common.blog' }
]

export function Header() {
  const t = useTranslation()
  const { pathname } = useRouter()
  const isCurrent = (href: string) =>
    pathname === href || pathname.startsWith(`${href}/`)

  return (
    <Popover as="header" className={styles.header}>
      {({ open, close }) => (
        <div className={styles.container}>
          <div className={styles.bar}>
            <Link href="/" className={styles.brand} onClick={() => close()}>
              <Image src="/static/favicon.png" alt="" width={30} height={30} />
              <span>HeyForm</span>
            </Link>

            <nav className={styles.desktopNav} aria-label="Primary navigation">
              {navItems.map(item => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={styles.navLink}
                  aria-current={isCurrent(item.href) ? 'page' : undefined}
                >
                  {t(item.label)}
                </Link>
              ))}
            </nav>

            <div className={styles.actions}>
              <a href="https://my.heyform.net" className={styles.login}>
                Log in
              </a>
              <a
                href="https://my.heyform.net/sign-up"
                className={styles.signup}
              >
                Get started
              </a>
              <Popover.Button
                className={styles.menuButton}
                aria-label={open ? 'Close menu' : 'Open menu'}
              >
                {open ? (
                  <IconX aria-hidden="true" />
                ) : (
                  <IconMenu2 aria-hidden="true" />
                )}
              </Popover.Button>
            </div>
          </div>

          <Transition
            as={Fragment}
            enter={styles.transition}
            enterFrom={styles.hidden}
            enterTo={styles.visible}
            leave={styles.transition}
            leaveFrom={styles.visible}
            leaveTo={styles.hidden}
          >
            <Popover.Panel focus className={styles.panel}>
              <nav aria-label="Primary navigation" className={styles.mobileNav}>
                {navItems.map(item => (
                  <Link
                    key={item.href}
                    href={item.href}
                    onClick={() => close()}
                    className={styles.mobileLink}
                    aria-current={isCurrent(item.href) ? 'page' : undefined}
                  >
                    {t(item.label)}
                  </Link>
                ))}
              </nav>
              <div className={styles.mobileAccount}>
                <a href="https://my.heyform.net">Log in to your account</a>
              </div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  )
}
